export const THEMES = {
    LIGHT: 'light',
    DARK: 'dark',
    SYSTEM: 'system',
};

export const PALETTE = {
    light: {
        background: '#FBF6F4',
        surface: '#EFEFEF', // Slightly darker than background for contrast
        textPrimary: '#111827', // gray-900
        textSecondary: '#737373',
        border: '#9C9C9C',
        accent: '#FF6B35',
        folderHighlight: '#7FFF00',
    },
    dark: {
        background: '#222831',
        surface: '#393E46',
        textPrimary: '#DFD0B8',
        textSecondary: '#948979',
        border: '#4F5866',
        accent: '#DFD0B8', // Using highlight color as accent
        folderHighlight: '#393E46', // Darker highlight for folders
    },
};
